export default __webpack_public_path__ + "static/media/Co-working_re_w93t.fcf84112.svg";